import { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query"

export const useDetailedProgramSession = (
  id: string,
  sessionDate: string | null,
  programId: string | null,
  programType: ProgramType | null,
) => {
  const { programInfiniteSessionApi, programOnOffSessionApi } = useServicesContext()
  const queryKey = ["programSession", id, programId, programType, sessionDate]

  const { data, refetch } = useSuspenseQuery({
    queryKey,
    queryFn: async () => {
      if (programType === ProgramType.VIRTUAL || programType === ProgramType.PRO)
        return ProgramInfiniteSessionEntity.fromDto(await programInfiniteSessionApi.getDetailedSession(id))
      else if (programType === ProgramType.ONOFF && programId)
        return ProgramOnOffSessionEntity.fromDto(
          await programOnOffSessionApi.getDetailedSession(id, programId, sessionDate ?? undefined),
        )
      else return null
    },
  })

  return {
    data,
    refetch,
  }
}

export const useDetailedProgramSessionInvalidate = (id?: string) => {
  const queryClient = useQueryClient()

  const invalidateQuerySession = () => {
    if (id) {
      void queryClient.invalidateQueries({
        queryKey: ["programSession", id],
      })
    }
  }
  return {
    invalidateQuerySession,
  }
}
